import React  from 'react'
import PropTypes from 'prop-types'
import { Box, Button, Grid } from '@mui/material'
import { useTranslation } from 'react-i18next'

const Pagination = ({ page, totalPages, rowsPerPage, onPageChange, onRowsPerPageChange, arrayRows }) => {
  const { t } = useTranslation('pagination')
 // Use arrayRows if provided, otherwise default to [20, 40, 60, 80, 100]
 const arrayRowsPerPage = arrayRows ? arrayRows : [20, 40, 60, 80, 100]
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end', // Aligne tout à droite
          alignItems: 'center',
          marginTop: '1rem',
        }}
      >
        <Grid container spacing={1} alignItems="center" justifyContent="flex-end">
          {/* Sélecteur de lignes par page */}
          <Grid item>
            <label style={{ marginRight: '8px' }}>{t('rowsPerPage')}</label>
            <select
              value={rowsPerPage}
              onChange={(e) => onRowsPerPageChange(parseInt(e.target.value, 10))}
              style={{ padding: '4px', fontSize: '1rem' }}
            >
              {/* On peut choisir de 1 à 10 */}
              {arrayRowsPerPage.map((rows) => (
                <option key={rows} value={rows}>
                  {rows}
                </option>
              ))}
            </select>
          </Grid>

          {/* Bouton de page précédente */}
          <Grid item>
            <Button
              variant="contained"
              onClick={() => onPageChange(page - 1, 'previous')}
              disabled={page === 0}
              sx={{ minWidth: 'fit-content' }}
            >
              {t('previous')}
            </Button>
          </Grid>

          {/* Affichage du numéro de page */}
          <Grid item>
            <span>
              {t('page')} {page + 1} of {totalPages}
            </span>
          </Grid>

          {/* Bouton de page suivante */}
          <Grid item>
            <Button
              variant="contained"
              onClick={() => onPageChange(page + 1, 'next')}
              disabled={page >= totalPages - 1}
              sx={{ minWidth: 'fit-content' }}
            >
              {t('next')}
            </Button>
          </Grid>
        </Grid>
      </Box>
    </>
  )
}

// Définition des propTypes pour la validation des propriétés
Pagination.propTypes = {
  page: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  onRowsPerPageChange: PropTypes.func.isRequired,
  arrayRows:PropTypes.array
}

export default Pagination
